import { tagAs } from 'factions/metatagger'
import { COMBAT_PHASE, HERO_PHASE, SHOOTING_PHASE } from 'types/phases'
import rule_sources from './rule_sources'
import { TItemDescriptions } from 'factions/factionTypes'

const Spells = {
  'Lore of Shadows': {
    effects: [
      {
        name: `Steed of Shadows: Casting value of 6 (UNLIMITED)`,
        desc: `Declare: Pick a friendly Daughters of Khaine Wizard to cast this spell, pick a visible friendly Daughters of Khaine unit wholly within 12" of them to be the target, then make a casting roll of 2D6. 
        Effect: The target can use Charge abilities this turn even if it used a Run ability in the same turn.`,
        when: [HERO_PHASE],
      },
      {
        name: `Black Horror of Ulgu: Casting value of 6`,
        desc: `Declare: Pick a friendly Daughters of Khaine Wizard to cast this spell, pick a point on the battlefield within 18" of them, pick up to 3 enemy units within 3" of that point to be the targets, then make a casting roll of 2D6.
        Effect: The targets cannot use Run abilities until the start of your next turn.`,
        when: [HERO_PHASE],
      },
      {
        name: `Mindrazor: Casting value of 7`,
        desc: `Declare: Pick a friendly Daughters of Khaine Wizard to cast this spell, pick a visible friendly Daughters of Khaine unit wholly within 12" of them to be the target, then make a casting roll of 2D6. 
        Effect: The target's melee weapons have Charge(+1 Damage) until the start of your next turn.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Zainthar Kai (AoR)': {
    effects: [
      {
        name: `Ethereal Grace: Casting value of 6 (UNLIMITED)`,
        desc: `Declare: Pick a friendly Zainthar Kai Wizard to cast this spell, pick a visible friendly Zainthar Kai unit wholly within 12" of them to be the target, then make a casting roll of 2D6. 
        Effect: Add 2" to the target's Move characteristic for the rest of the turn.`,
        when: [HERO_PHASE],
      },
      {
        name: `On Wings of Shadow: Casting value of 7`,
        desc: `Declare: Pick a friendly Zainthar Kai Wizard to cast this spell, pick a visible friendly Zainthar Kai unit wholly within 12" of them to be the target, then make a casting roll of 2D6.
        Effect: Remove the target from the battlefield and set it up again on the battlefield more than 9" from all enemy units.`,
        when: [HERO_PHASE],
      },
      {
        name: `Speed of the Scathborn: Casting value of 7`,
        desc: `Declare: Pick a friendly Zainthar Kai Wizard to cast this spell, pick a visible friendly Zainthar Kai unit wholly within 12" of them to be the target, then make a casting roll of 2D6.
        Effect: The target has Strike-First for the rest of the turn.`,
        when: [HERO_PHASE],
      },
      {
        name: `Manifestations of Murder: Casting value of 7 (UNLIMITED)`,
        desc: `Declare: Pick a friendly Zainthar Kai Wizard to cast this spell, pick 1 of the friendly Manifestations below that is not on the battlefield, then make a casting roll of 2D6.
        Bloodwrack Viper
        Bladewind
        Heart of Fury 
        Effect: If you picked a Bloodwrack Viper or Bladewind, set it up wholly within 12" of the chanter, visible to them and more thena 9" from all enemy units. If you picked a Heart of Fury, set it up wholly within 18" of the chanter and visible to them. If the chanting roll was 10+, you can pick a second Manifestation from the list above that is not on the battlefield and set it up as described above.`,
        when: [HERO_PHASE],
      },
      {
        name: `Bladewind - Unnatural Edge`,
        desc: `Declare: If this Manifestation charged this turn, pick an enemy unit in combat with it to be the target. 
        Effect: If any damage points are allocated to the target this phase by this Manifestation's combat attacks, ward rolls cannot be made for the target for the rest of the battle.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Bloodwrack Viper - Crushing Coils`,
        desc: `Declare: Pick an enemy Hero  or Monster in combat with this Manifestation to be the target. 
        Effect: Roll a dice. On a 3+, the target has Strike-Last for the rest of the turn.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Bloodwrack Viper - Bind and Bite - Passive`,
        desc: `Effect: This unit's combat attacks score critical hits on unmodified hit rolls of 4+ if the target of those attacks has Strike-Last.`,
        when: [COMBAT_PHASE],
      },
        
      {
        name: `Heart of Fury - Locus of the Murder God - Passive`,
        desc: `Effect: Subtract 1 from wound rolls for attacks that target friendly Daughters of Khaine Infantry units while they are wholly within 12" of this Manifestation.`,
        when: [SHOOTING_PHASE, COMBAT_PHASE],
      },
    ],
  },
} satisfies TItemDescriptions

export default tagAs(Spells, 'spell')
